import DropdownMenu from "@innologica/vue-dropdown-menu";
import { mapGetters } from "vuex";
import store from "@/store";
import axios from "axios";
import { fetchNotificationCount } from "@/services/common/notification-service";

export default {
    name: "Header",

    components: {
        DropdownMenu
    },

    data() {
        return {
            showNav: false,
            show: false,
            userInfo: store.state.user.accountuser,
            authInfo: {},
            userData: store.state.user,
            isuser: this.$store.state.user.length == 0 ? false : true,
        };
    },

    computed: {
        ...mapGetters({
            teacherId: "teacherId",
            studentId: "studentId",
            schoolId : "schoolId",
            count: "count",
            userSocialID: 'userSocialID'
        }),
    },

    methods: {
        toggleNavbar() {
            this.showNav = !this.showNav;
        },
        logout() {
            return axios.post("logout")
                .then(() => {
                    this.$store.commit('logout');
                    window.location.replace('/');
                })
                .catch((error) => {
                    console.log("Log Out API Error", error.response);
                });
        },
        getDetailUser() {
            let id = null;
            switch (this.userData.usertype) {
                case 'teacher':
                    id = this.userData.accountuser.teacher_id
                break
                case 'student':
                    id = this.userData.accountuser.student_id
                break
                case 'school' :
                    id = this.userData.accountuser.school_id
                break
            }
            if (id != null) {
                axios.get("/profile")
                    .then((response) => {
                        this.authInfo = response.data;
                        store.commit("setUserStatus", response.data.status);
                        store.commit("setUserEnableVideoUpload", response.data.enable_video_upload);
                    })
                    .catch((error) => {
                        if (error.response.status == 401) {
                            this.$store.commit('logout');
                            window.location.replace('/');
                        }
                        console.log("User Detail API Error", error);
                });
            }
        },
    },

    mounted() {
        this.getDetailUser();
        fetchNotificationCount();
    }
};
